import { useEffect, useState } from "react";
import styles from "./Styles.module.css";
import { getUtils, selectAllSessions } from "../DAL/dal";
import { exportExcel } from "../Utils/utils";
import { useParams } from "react-router-dom";

const Excel = ({}) => {
  const [state, setState] = useState([]);
  const [utils, setUtils] = useState(null);
  const { id } = useParams();
  const [password, setPassword] = useState("");
  const typePassword = (e) => {
    setPassword(e.target.value);
  };
  useEffect(() => {
    selectAllSessions(id).then((r) => {
      setState(
        r.sort(function (a, b) {
          return new Date(b.startedtime) - new Date(a.startedtime);
        })
      );
      getUtils(id).then((res) => setUtils(res));
    });
  }, []);

  return (
    <>
      {password == "Dv1Sfarv" ? (
        <section
          style={{
            width: "100vw",
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            className="buttonNext"
            onClick={() => {
              exportExcel(state, utils);
            }}
          >
            Скачать отчет
          </button>
        </section>
      ) : (
        <>
          <input
            className="password-style"
            type="text"
            placeholder="пароль"
            onChange={typePassword}
            value={password}
          />
        </>
      )}
    </>
  );
};

export default Excel;
